/**
 * Created by Omar Alejandro Leonor Avalos on 2017-08-11.
 * Definitions for:
 * Services
 * Expenses
 * Bill types
 */
import React from 'react';
import { isEmpty } from 'lodash';
import { feeTax } from '../../app.config';

//Concepto, Aplicable, Precio Unitario, Cantidad, Importe -- Servicios
//Concepto, Aplicable, Importe -- Gastos
export const serviceColumns = [
    {
        prop: 'invoiceItem',
        title: 'Concepto',
        type: 'remote_autocomplete',
        colClass: 'col-md-3 col-xs-12',
        showAsLabel: (row) => row.useLabel,
        customLabel: (row) => row.invoiceItem.concept
    },
    {
        prop: 'applicableRepresentation',
        title: 'Aplicables',
        type: 'label',
        colClass: 'col-md-3 col-xs-12',
        calculateValue: (row) => row.invoiceItem.applicableRepresentation || '- - -'
    },
    {
        prop: 'priceValue',
        title: 'Precio Unitario',
        type: 'number',
        colClass: 'col-md-2 col-xs-12',
        disabled: (row) => isEmpty(row.invoiceItem)
    },
    {
        prop: 'numberOfItems',
        title: 'Cantidad',
        type: 'number',
        colClass: 'col-md-1 col-xs-12',
        disabled: (row) => isEmpty(row.invoiceItem)
    },
    {
        prop: 'amount',
        title: 'Importe',
        type: 'label',
        colClass: 'col-md-2 col-xs-12',
        calculateValue: (row) =>
            <label
                htmlFor="_"
                style={{ width: '100%' }}
                className="display-flex-just-end"
            >
                {((row.priceValue || 0) * (row.numberOfItems || 0)).formatMoney()}
            </label>
    }
];

export const gastosColumns = [
    {
        prop: 'invoiceItem',
        title: 'Concepto',
        type: 'remote_autocomplete',
        colClass: 'col-md-4 col-xs-12',
        showAsLabel: (row) => row.useLabel,
        customLabel: (row) => row.invoiceItem.concept
    },
    {
        prop: 'applicableRepresentation',
        title: 'Aplicables',
        type: 'label',
        colClass: 'col-md-4 col-xs-12',
        calculateValue: (row) => row.invoiceItem.applicableRepresentation || '- - -'
    },
    {
        prop: 'amount',
        title: 'Importe',
        type: 'number',
        colClass: 'col-md-3 col-xs-12',
        disabled: (row) => isEmpty(row.invoiceItem),
        calculateValue: (row) =>
            <label
                htmlFor="_"
                style={{ width: '100%' }}
                className="display-flex-just-end"
            >
                {(row.priceValue || 0).formatMoney()}
            </label>
    }
];

export const PRE_INVOICE_TYPES = [
    {
        id: '1',
        name: 'AAA SERVICIOS (+IVA) & GASTOS COMPROBADOS (SIN IVA) ',
        tax: true,
        aditionalTax: false,
        retentions: false,
        expenses: true,
        services: true,
        creditNote: false,
        loadFlete: false,
        tabular: true, //Uses (tabular values, fee, and complementary)
        getSubtotal: (concepts, feeAmount, complementary) => calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getTax: (concepts, feeAmount, complementary) => getTax(concepts, feeAmount, complementary),
        getAditionalTax: () => 0,
        getRetentions: () => 0,
        getTotal: (concepts, feeAmount, complementary) => getTax(concepts, feeAmount, complementary) + calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getFee: (concepts, feeValue, customHouseValue, minFee, numberOfItems) => getFee(concepts, feeValue, customHouseValue, minFee, numberOfItems),
        getExpenseRatio: (concepts) => getExpenseRatio(concepts)
    },
    {
        id: '2',
        name: 'AAA SERVICIOS (SIN IVA)  & GASTOS COMPROBADOS (SIN IVA)',
        tax: false,
        aditionalTax: false,
        retentions: false,
        expenses: true,
        services: true,
        creditNote: false,
        loadFlete: false,
        tabular: true, //Uses (tabular values, fee, and complementary)
        getSubtotal: (concepts, feeAmount, complementary) => calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getTax: () => 0,
        getAditionalTax: () => 0,
        getRetentions: () => 0,
        getTotal: (concepts, feeAmount, complementary) => calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getFee: (concepts, feeValue, customHouseValue, minFee, numberOfItems) => getFee(concepts, feeValue, customHouseValue, minFee, numberOfItems),
        getExpenseRatio: (concepts) => getExpenseRatio(concepts)
    },
    {
        id: '3',
        name: 'AAA GASTOS COMPROBADOS *SIN XML* (SIN IVA)',
        tax: false,
        aditionalTax: false,
        retentions: false,
        expenses: true,
        services: false,
        creditNote: false,
        loadFlete: false,
        tabular: false, //Uses (tabular values, fee, and complementary)
        getSubtotal: () => 0,
        getTax: () => 0,
        getAditionalTax: () => 0,
        getRetentions: () => 0,
        getTotal: () => 0,
        getFee: () => 0,
        getExpenseRatio: (concepts) => getExpenseRatio(concepts)
    },
    {
        id: '4',
        name: 'AAA NOTAS DE CREDITO (SIN IVA)',
        tax: false,
        aditionalTax: false,
        retentions: false,
        expenses: false,
        services: true,
        creditNote: true,
        loadFlete: false,
        tabular: false, //Uses (tabular values, fee, and complementary)
        getSubtotal: (concepts, feeAmount, complementary) => calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getTax: () => 0,
        getAditionalTax: () => 0,
        getRetentions: () => 0,
        getTotal: (concepts, feeAmount, complementary) => calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getFee: () => 0,
        getExpenseRatio: () => 0
    },
    {
        id: '5',
        name: 'AAA NOTAS DE CREDITO (CON IVA)',
        tax: true,
        aditionalTax: false,
        retentions: false,
        expenses: false,
        services: true,
        creditNote: true,
        loadFlete: false,
        tabular: false, //Uses (tabular values, fee, and complementary)
        getSubtotal: (concepts, feeAmount, complementary) => calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getTax: (concepts, feeAmount, complementary) => getTax(concepts, feeAmount, complementary),
        getAditionalTax: () => 0,
        getRetentions: () => 0,
        getTotal: (concepts, feeAmount, complementary) => getTax(concepts, feeAmount, complementary) + calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getFee: () => 0,
        getExpenseRatio: () => 0
    },
    {
        id: '6',
        name: 'AFST FLETES NACIONALES  (+IVA - RET)',
        tax: true,
        aditionalTax: true,
        retentions: true,
        expenses: false,
        services: true,
        creditNote: false,
        loadFlete: true,
        tabular: false, //Uses (tabular values, fee, and complementary)
        getSubtotal: (concepts, feeAmount, complementary) => calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getTax: (concepts, feeAmount, complementary) => getTax(concepts, feeAmount, complementary),
        getAditionalTax: (concepts) => getAditionalTax(concepts),
        getRetentions: (concepts) => getRetentions(concepts),
        getTotal: (concepts, feeAmount, complementary) => (getTax(concepts, feeAmount, complementary) + getAditionalTax(concepts) + calculateSubtotalWithFee(concepts, feeAmount, complementary)) - getRetentions(concepts),
        getFee: () => 0,
        getExpenseRatio: () => 0
    },
    {
        id: '7',
        name: 'AFST SERVICIO VARIOS (+IVA)',
        tax: true,
        aditionalTax: false,
        retentions: false,
        expenses: false,
        services: true,
        creditNote: false,
        loadFlete: false,
        tabular: false, //Uses (tabular values, fee, and complementary)
        getSubtotal: (concepts, feeAmount, complementary) => calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getTax: (concepts, feeAmount, complementary) => getTax(concepts, feeAmount, complementary),
        getAditionalTax: () => 0,
        getRetentions: () => 0,
        getTotal: (concepts, feeAmount, complementary) => getTax(concepts, feeAmount, complementary) + calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getFee: () => 0,
        getExpenseRatio: () => 0
    },
    {
        id: '8',
        name: 'AFST NOTAS DE CREDITO (SIN IVA)',
        tax: false,
        aditionalTax: false,
        retentions: false,
        expenses: false,
        services: true,
        creditNote: true,
        loadFlete: false,
        tabular: false, //Uses (tabular values, fee, and complementary)
        getSubtotal: (concepts, feeAmount, complementary) => calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getTax: () => 0,
        getAditionalTax: () => 0,
        getRetentions: () => 0,
        getTotal: (concepts, feeAmount, complementary) => calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getFee: () => 0,
        getExpenseRatio: () => 0
    },
    {
        id: '9',
        name: 'AFST NOTAS DE CREDITO (CON IVA)',
        tax: true,
        aditionalTax: false,
        retentions: false,
        expenses: false,
        services: true,
        creditNote: true,
        loadFlete: false,
        tabular: false, //Uses (tabular values, fee, and complementary)
        getSubtotal: (concepts, feeAmount, complementary) => calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getTax: (concepts, feeAmount, complementary) => getTax(concepts, feeAmount, complementary),
        getAditionalTax: () => 0,
        getRetentions: () => 0,
        getTotal: (concepts, feeAmount, complementary) => getTax(concepts, feeAmount, complementary) + calculateSubtotalWithFee(concepts, feeAmount, complementary),
        getFee: () => 0,
        getExpenseRatio: () => 0
    }
];

//HELPERS TO CALCULATE VALUES
const getSubtotal = (concepts) => {
    let subtotal = 0;

    concepts.forEach(concept => {
        subtotal += (concept.priceValue * concept.numberOfItems);
    });

    return Number(subtotal);
};

const getExpenseRatio = (concepts) => {
    let total = 0;

    concepts.forEach(concept => {
        total += Number(concept.amount);
    });

    return Number(total);
};

const getByCustomProp = (concepts, prop) => {
    let total = 0;

    concepts.forEach(concept => {
        const xApplicable = concept.invoiceItem[prop] || 0;
        const amount = concept.priceValue * concept.numberOfItems;
        const value = (amount * xApplicable) / 100;
        total += value;
    });

    return Number(total);
};

const getTax = (concepts, feeAmount, fee) => {
    //feeTax is inside app.config
    const complementary = fee.complementary || 0;
    const flatValue = fee.flatValue || 0;

    return getByCustomProp(concepts, 'tax') + ((feeAmount * feeTax) / 100) + ((complementary * feeTax) / 100) + ((flatValue * feeTax) / 100);
};

const getAditionalTax = (concepts) => {
    return getByCustomProp(concepts, 'aditionalTax');
};

const getRetentions = (concepts) => {
    return getByCustomProp(concepts, 'retentions');
};

const getFee = (concepts, feeValue, customHouseValue, minFee, numberOfItems) => {
    const sub = getExpenseRatio(concepts) + customHouseValue;
    const totalFee = (sub * feeValue) / 100;

    if (totalFee < minFee) {
        return minFee * numberOfItems;
    }

    return totalFee * numberOfItems;
};

const calculateSubtotalWithFee = (concepts, feeAmount = 0, fee) => {
    return getSubtotal(concepts) + feeAmount + (fee.complementary || 0) + (fee.flatValue || 0);
};



// WEBPACK FOOTER //
// ./forms/customPrefactura/definitions.js